import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  filtersContainer,
  filter,
  filterDarkTheme,
  filterLightTheme,
  filterBasicTheme,
  selectedFilter,
} from './scss/Filters.module.scss';

const Filters = ({ options, selected, onSelect, theme, className }) => {
  const isControlled = Boolean(selected);
  const defaultOption = isControlled ? selected : options[0];
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const handleClick = selectedOption => {
    setSelectedOption(selectedOption);
    onSelect(selectedOption);
  };
  const themeClassName = {
    dark: filterDarkTheme,
    light: filterLightTheme,
    basic: filterBasicTheme,
  }[theme];

  return (
    <section className={classNames(filtersContainer, className)}>
      {options.map(option => (
        <button
          key={option}
          className={classNames(filter, themeClassName, {
            [selectedFilter]: selectedOption === option,
          })}
          onClick={() => handleClick(option)}
          aria-label={option}
        >
          {option}
        </button>
      ))}
    </section>
  );
};

Filters.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark', 'basic']),
};

Filters.defaultProps = {
  className: '',
  theme: 'dark',
  onSelect: () => {},
};

export default Filters;
